import React from "react";
import { PropTypes } from "prop-types";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import "./bar.scss";
import CustomTooltip from "./customTooltip";
import Logger from "../../utils/logger";

const CustomizedAxisTick = ({
  x,
  y,
  payload
}) => React.createElement("g", {
  transform: "translate(".concat(x, ",").concat(y, ")")
}, React.createElement("text", {
  x: 0,
  y: 0,
  dy: 16,
  textAnchor: "start",
  transform: "rotate(20)",
  fill: "#666",
  fontSize: "11px"
}, payload.value));

CustomizedAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({})
};

const LABEL_OPTIONS = (label = "%") => ({
  position: "top",
  content: props => {
    return "".concat(Number(Number(props.value).toFixed(2)).toLocaleString("es")).concat(label);
  }
});

const AtresBarChart = ({
  data,
  type,
  visibles,
  dataKey = "votesPerent",
  isSenate,
  labelAbrv,
  slice = 6
}) => {
  let unitAbrv = !isSenate ? "escaños" : "senadores";
  Logger.log("AtresBarChart", "nuevo render", data.slice(0, 10), "ChartData");
  let showData = JSON.parse(JSON.stringify(data));
  showData = dataKey === "seats" ? showData.filter(current => current.seats >= 1).slice(0, 10) : showData.reduce((filtered, option) => {
    if (option.votesPercent > 0) {
      option.votesPercent = parseFloat(Number.parseFloat(option.votesPercent).toFixed(1));
      filtered.push(option);
    }

    return filtered;
  }, []).slice(0, slice);
  return React.createElement(ResponsiveContainer, {
    minHeight: "200px",
    height: "60%"
  }, React.createElement(BarChart, {
    data: showData,
    margin: {
      top: 15,
      right: 30,
      left: 20,
      bottom: 5
    }
  }, React.createElement(Tooltip, {
    content: React.createElement(CustomTooltip, {
      unitName: unitAbrv,
      isSenate: isSenate
    })
  }), React.createElement(XAxis, {
    height: 75,
    type: "category",
    dataKey: "partyAcronym",
    allowDataOverflow: true,
    interval: 0,
    tickMargin: -5,
    isAnimationActive: false,
    tick: React.createElement(CustomizedAxisTick, null)
  }), React.createElement(Bar, {
    dataKey: dataKey,
    fill: "#8884d8",
    label: LABEL_OPTIONS(labelAbrv),
    isAnimationActive: false
  }, showData.map((entry, index, arr) => {
    return React.createElement(Cell, {
      key: "".concat(entry.partyAcronym, "_").concat(entry.votes),
      fill: entry.partyColor
    });
  }))));
};

export default AtresBarChart;